(() => {
  const root = document.querySelector('product-info');
  const decision = root?.querySelector('[data-cb-decision-support]');
  const details = root?.querySelector('[data-cb-product-details]');
  if (!root || !decision || !details || decision.dataset.enhanced === 'true') return;
  decision.dataset.enhanced = 'true';

  const description = root.querySelector('.product__description');
  const text = (description?.innerText || decision.dataset.productDescription || '')
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  const clean = (value = '') => value
    .replace(/^[\s:–—-]+|[\s:–—-]+$/g, '')
    .replace(/\s*\n\s*/g, ' · ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const sectionValue = (labels, stopLabels, max = 520) => {
    const start = new RegExp(`(?:^|\\n)\\s*(?:${labels.join('|')})\\s*:?\\s*`, 'i').exec(text);
    if (!start) return '';
    const tail = text.slice(start.index + start[0].length, start.index + start[0].length + max);
    const stop = new RegExp(`(?:\\n\\s*)+(?:${stopLabels.join('|')})\\s*:?`, 'i').exec(tail);
    return clean(stop ? tail.slice(0, stop.index) : tail);
  };

  const dimensionLabels = ['Overall Height', 'Overall Width', 'Overall Depth', 'Seat Height', 'Seat Width', 'Seat Depth', 'Arm Height', 'Height', 'Width', 'Depth', 'Length', 'Diameter'];
  const dimensionRows = [];
  const dimensionBlock = sectionValue(
    ['Measurements?', 'Dimensions?(?:\\s*\\([^\\n)]*\\))?'],
    ['Condition', 'Shipping(?: Time)?', 'Delivery', 'Materials?', 'Care', 'Additional Details?', '(?:📦|🚚)?\\s*FREE Shipping', 'Need More Info'],
    700
  );
  const dimensionPattern = new RegExp(`(?:^|\\n|·|•)\\s*(${dimensionLabels.join('|')})\\s*:?\\s*([^\\n·•]{1,48})`, 'gi');
  let dimensionMatch;
  const dimensionSearchText = dimensionBlock || text;
  while ((dimensionMatch = dimensionPattern.exec(dimensionSearchText)) && dimensionRows.length < 9) {
    const label = clean(dimensionMatch[1]);
    const value = clean(dimensionMatch[2]).split(/(?:Condition|Shipping|Delivery|Materials?)\s*:/i)[0].trim();
    if (value && !dimensionRows.some(([existing]) => existing.toLowerCase() === label.toLowerCase())) dimensionRows.push([label, value]);
  }
  if (dimensionBlock && dimensionRows.length < 9) {
    const valueFirstPattern = /(\d+(?:\.\d+)?\s*[″”"]?)\s*(H|W|D|L)\b/gi;
    const shorthandLabels = { H: 'Height', W: 'Width', D: 'Depth', L: 'Length' };
    let valueFirstMatch;
    while ((valueFirstMatch = valueFirstPattern.exec(dimensionBlock)) && dimensionRows.length < 9) {
      const label = shorthandLabels[valueFirstMatch[2].toUpperCase()];
      if (label && !dimensionRows.some(([existing]) => existing === label)) dimensionRows.push([label, clean(valueFirstMatch[1])]);
    }
  }
  if (!dimensionRows.length) {
    const compact = /\b\d+(?:\.\d+)?\s*[″”"]?\s*[LlWw]\s*[×x]\s*\d+(?:\.\d+)?\s*[″”"]?\s*[WwDd]\s*[×x]\s*\d+(?:\.\d+)?\s*[″”"]?\s*[Hh]\b/.exec(dimensionBlock || text);
    if (compact) dimensionRows.push(['Overall', clean(compact[0])]);
  }

  const dimensionOutput = details.querySelector('[data-cb-dimensions-output]');
  const decisionDimension = decision.querySelector('[data-cb-decision-dimensions] dd');
  if (dimensionRows.length) {
    const list = document.createElement('dl');
    list.className = 'cb-object-details';
    list.innerHTML = dimensionRows.map(([label, value]) => `<div><dt></dt><dd></dd></div>`).join('');
    [...list.children].forEach((row, index) => {
      row.querySelector('dt').textContent = dimensionRows[index][0];
      row.querySelector('dd').textContent = dimensionRows[index][1];
    });
    dimensionOutput.replaceChildren(list);
    decisionDimension.textContent = dimensionRows.slice(0, 4).map(([label, value]) => `${label}: ${value}`).join(' · ');
  }

  const condition = sectionValue(
    ['Condition', 'Condition Notes?', 'Vintage Condition', 'New\\s*\\/\\s*Made to Order'],
    ['Shipping(?: Time)?', 'Delivery', 'Dimensions?', 'Measurements?', 'Materials?', 'Care', 'Additional Details?', '(?:📦|🚚)?\\s*FREE Shipping', 'Need More Info'],
    700
  );
  const cleanCondition = condition.split(/\s*·?\s*(?:📦|🚚|�)/u)[0].trim();
  if (cleanCondition) {
    const conditionOutput = details.querySelector('[data-cb-condition-output]');
    const paragraph = document.createElement('p');
    paragraph.textContent = cleanCondition;
    conditionOutput.replaceChildren(paragraph);
  }

  const materialMap = [
    ['walnut', 'Walnut'], ['rosewood', 'Rosewood'], ['teak', 'Teak'], ['oak', 'Oak'], ['mahogany', 'Mahogany'],
    ['burl', 'Burl wood'], ['maple', 'Maple'], ['pine', 'Pine'], ['cherry', 'Cherry'], ['rattan', 'Rattan'],
    ['wicker', 'Wicker'], ['rush', 'Rush'], ['leather', 'Leather'], ['vinyl', 'Vinyl'], ['velvet', 'Velvet'],
    ['linen', 'Linen'], ['boucle', 'Bouclé'], ['wool', 'Wool'], ['brass', 'Brass'], ['bronze', 'Bronze'],
    ['chrome', 'Chrome'], ['steel', 'Steel'], ['aluminum', 'Aluminum'], ['lucite', 'Lucite'], ['acrylic', 'Acrylic'],
    ['glass', 'Glass'], ['travertine', 'Travertine'], ['marble', 'Marble'], ['stone', 'Stone'], ['plaster', 'Plaster'],
    ['laminate', 'Laminate'], ['ceramic', 'Ceramic']
  ];
  const materialSource = `${decision.dataset.productTitle || ''} ${decision.dataset.productTags || ''}`.toLowerCase();
  const materials = materialMap.filter(([needle]) => materialSource.includes(needle)).map(([, label]) => label);
  const uniqueMaterials = [...new Set(materials)].slice(0, 8);
  const materialsRow = details.querySelector('[data-cb-materials-row]');
  if (uniqueMaterials.length) {
    materialsRow.hidden = false;
    materialsRow.querySelector('[data-cb-materials-output]').textContent = uniqueMaterials.join(', ');
  }

  root.querySelectorAll('.product__accordion').forEach((accordion) => {
    const heading = accordion.querySelector('.accordion__title')?.textContent.trim().toLowerCase();
    const content = accordion.querySelector('.accordion__content');
    if (!content) return;
    if (heading === 'materials' && uniqueMaterials.length && !content.textContent.trim()) content.textContent = uniqueMaterials.join(', ');
    if (heading === 'dimensions' && dimensionRows.length && !content.textContent.trim()) {
      content.innerHTML = dimensionRows.map(([label, value]) => `<p><strong></strong> <span></span></p>`).join('');
      [...content.children].forEach((row, index) => {
        row.querySelector('strong').textContent = `${dimensionRows[index][0]}:`;
        row.querySelector('span').textContent = dimensionRows[index][1];
      });
    }
    if (!content.textContent.trim()) accordion.hidden = true;
  });

  const publishInteraction = (action, detail = '') => {
    const payload = {
      action,
      detail,
      product_id: decision.dataset.productId,
      product_url: location.pathname
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cb_product_interaction',
      ...payload
    });
    window.Shopify?.analytics?.publish?.('casa_bauhaus:pdp_interaction', payload)?.catch?.(() => {});
  };

  root.querySelector('[id^="GalleryViewer-"]')?.addEventListener('click', () => publishInteraction('gallery_engaged'), { once: true });
  decision.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (link) publishInteraction('decision_link', link.textContent.trim());
  });
  root.querySelector('[data-cb-product-details]')?.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (link) publishInteraction('detail_link', link.textContent.trim());
  });
  root.querySelector('.product-concierge__request summary')?.addEventListener('click', () => publishInteraction('inquiry_opened'));
  root.querySelector('button[name="add"]')?.addEventListener('click', () => publishInteraction('add_to_cart_clicked'));
  root.querySelectorAll('.product__accordion details').forEach((item) => item.addEventListener('toggle', () => {
    if (item.open) publishInteraction('accordion_opened', item.querySelector('summary')?.innerText.trim() || '');
  }));

  if ('IntersectionObserver' in window) {
    const observed = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        publishInteraction(entry.target.matches('[data-cb-product-details]') ? 'details_viewed' : 'condition_viewed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.45 });
    observed.observe(details);
    observed.observe(details.querySelector('[id^="ConditionReport-"]'));
  }
})();
